
import React from "react";
import { useFormContext } from "react-hook-form";
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import PricingSelector from "@/components/agent-upload/PricingSelector";
import { AgentFormData } from "@/models/agent-form";

const PricingSection: React.FC = () => {
  const form = useFormContext<AgentFormData>();
  
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-medium">Pricing</h3>
      
      <FormField
        control={form.control}
        name="pricingModel"
        render={({ field }) => (
          <FormItem>
            <FormControl>
              <PricingSelector
                value={field.value}
                price={form.watch("price")}
                onPricingChange={(value) => {
                  field.onChange(value);
                  if (value === "free") {
                    form.setValue("price", undefined);
                  }
                }}
                onPriceChange={(value) => form.setValue("price", value)}
                error={form.formState.errors.pricingModel?.message}
                priceError={form.formState.errors.price?.message}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};

export default PricingSection;
